import React from 'react'
import { BillingDashboard } from '../Pages/Plans&Billing/BillingDashboard'

function BillingPage() {
  return (
    <>
        <BillingDashboard />
    </>
  )
}

export default BillingPage
